import Investments from '@/components/Investment/Investment'
import investmentOpportunities from '@/components/InvestmentOpportunity/InvestmentOpportunity'
import createInvestmentOpportunity from '@/components/InvestmentOpportunity/CreateInvestmentOpportunity'
import CreateCompanyInvestment from '@/components/Investment/CreateCompanyInvestment'
import CreatePropertyInvestment from '@/components/Investment/CreatePropertyInvestment'
import Enum from '@/shared/enum'

let investmentsRoutes = [
  {
    meta: {
      title: 'menu.investments',
      ico: 'money',
      permission: ['Pages.Investments'],
    },
    path: '/projects/investments',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'investments',
        path: '',
        component: Investments,
        meta: {permission: ['Pages.Investments.View']},
      },
      {
        name: 'investments_company',
        path: '/projects/company/:project_id/investments',
        meta: {permission: ['Pages.Investments.View']},
        component: Investments,
      },
      {
        name: 'investments_property',
        path: '/projects/property/:project_id/investments',
        meta: {permission: ['Pages.Investments.View']},
        component: Investments,
      },
      {
        name: 'investments_company_create',
        path: '/projects/company/:project_id?/investments/create',
        meta: {permission: ['Pages.Investments.Create']},
        props: {compMode: Enum.Mode.CREATE},
        component: CreateCompanyInvestment,
      },
      {
        name: 'investments_property_create',
        path: '/projects/property/:project_id?/investments/create',
        meta: {permission: ['Pages.Investments.Create']},
        props: {compMode: Enum.Mode.CREATE},
        component: CreatePropertyInvestment,
      },
      {
        name: 'investments_company_edit',
        path: '/projects/company/investments/edit/:id',
        meta: {permission: ['Pages.Investments.Create']},
        props: {compMode: Enum.Mode.UPDATE},
        component: CreateCompanyInvestment,
      },
      {
        name: 'investments_property_edit',
        path: '/projects/property/investments/edit/:id',
        meta: {permission: ['Pages.Investments.Create']},
        props: {compMode: Enum.Mode.UPDATE},
        component: CreatePropertyInvestment,
      },
      {
        name: 'investments_company_view',
        path: '/projects/company/investments/view/:id',
        meta: {permission: ['Pages.Investments.View']},
        props: {compMode: Enum.Mode.READ},
        component: CreateCompanyInvestment,
      },
      {
        name: 'investments_property_view',
        path: '/projects/property/investments/view/:id',
        meta: {permission: ['Pages.Investments.View']},
        props: {compMode: Enum.Mode.READ},
        component: CreatePropertyInvestment,
      },
      {
        name: 'investments_company_copy',
        path: '/projects/company/investments/copy/:id',
        meta: {permission: ['Pages.Investments.Create']},
        props: {compMode: Enum.Mode.COPY},
        component: CreateCompanyInvestment,
      },
      {
        name: 'investments_property_copy',
        path: '/projects/property/investments/copy/:id',
        meta: {permission: ['Pages.Investments.Create']},
        props: {compMode: Enum.Mode.COPY},
        component: CreatePropertyInvestment,
      },
    ],
  },
  {
    meta: {
      title: 'menu.investmentOpportunities',
      ico: 'money',
      permission: ['Pages.Investments'],
    },
    path: '/projects/investment_opportunities',
    component: {template: '<router-view/>'},
    children: [
      {
        name: 'investment_opportunities',
        path: '',
        component: investmentOpportunities,
        meta: {permission: ['Pages.Investments.View']},
      },
      {
        name: 'investment_opportunity_innovation_view',
        path: '/projects/investment_opportunities/innovation/view/:id',
        component: createInvestmentOpportunity,
        props: {compMode: Enum.Mode.READ, projectType: 1},
      },
      {
        name: 'investment_opportunity_property_view',
        path: '/projects/investment_opportunities/property/view/:id',
        component: createInvestmentOpportunity,
        props: {compMode: Enum.Mode.READ, projectType: 2},
      },
      {
        name: 'investment_opportunity_innovation_edit',
        path: '/projects/investment_opportunities/innovation/edit/:id',
        component: createInvestmentOpportunity,
        props: {compMode: Enum.Mode.UPDATE, projectType: 1},
      },
      {
        name: 'investment_opportunity_property_edit',
        path: '/projects/investment_opportunities/property/edit/:id',
        component: createInvestmentOpportunity,
        props: {compMode: Enum.Mode.UPDATE, projectType: 2},
      },
      {
        name: 'investment_opportunity_property_create',
        path: '/projects/investment_opportunities/property/create/',
        component: createInvestmentOpportunity,
        props: {compMode: Enum.Mode.CREATE, projectType: 2},
      },
      {
        name: 'investment_opportunity_innovation_create',
        path: '/projects/investment_opportunities/innovation/create',
        component: createInvestmentOpportunity,
        props: {compMode: Enum.Mode.CREATE, projectType: 1},
      },
      {
        name: 'investment_opportunity_property_copy',
        path: '/projects/investment_opportunities/property/copy/:id',
        component: createInvestmentOpportunity,
        props: {compMode: Enum.Mode.COPY, projectType: 2},
      },
      {
        name: 'investment_opportunity_innovation_copy',
        path: '/projects/investment_opportunities/innovation/copy/:id',
        component: createInvestmentOpportunity,
        props: {compMode: Enum.Mode.COPY, projectType: 1},
      },
    ],
  },
]

export default investmentsRoutes



// WEBPACK FOOTER //
// ./src/router/investments.js